import React from "react";
import { connect } from "react-redux";
import { ActiveLicenseInfo } from "./ActiveLicenseInfo";
import NewLicenseSection from "./NewLicenseSection";
import ActiveLicenseInfoSkeleton from "./ActiveLicenseInfoSkeleton";

function LicenseInfoSection({ license, machineData, loading }) {


    return (
        <div className="p-3">
            {loading ? (
                <ActiveLicenseInfoSkeleton />
            ) : Object.keys(license).length ? (
                <ActiveLicenseInfo license={license} machineData={machineData} />
            ) : (
                <NewLicenseSection machineData={machineData} />
            )}
        </div>
    )

}

function mapStateToProps(state) {
    return {
        license: state.licensePage.license || {},
        machineData: state.licensePage.machineData || {}
    }
}

export default connect(mapStateToProps)(LicenseInfoSection);